import { trackFocusMethod } from './utils';
import MainController from './main-controller';

trackFocusMethod();
new MainController();
